import 'moment-timezone';
import './i18n/config';

import { GoogleOAuthProvider } from '@react-oauth/google';
import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// eslint-disable-next-line import/order
import './assets/css/app.css';
import './assets/css/prosemirror.css';
import './assets/scss/app.scss';
import './assets/scss/customer-portal.scss';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-photo-view/dist/react-photo-view.css';
import 'react-toastify/dist/ReactToastify.css';

import Loader from './components/Loader';
import useKeyboardAdjustments from './hooks/useKeyboardAdjustments';
import { store, persistor } from './redux/store';
import Routes from './routes';

function App() {
    useKeyboardAdjustments();

    return (
        <Provider store={store}>
            <PersistGate loading={<Loader />} persistor={persistor}>
                <GoogleOAuthProvider clientId={`${window.GOOGLE_SIGNIN_CLIENT_ID}`}>
                    <Routes />
                </GoogleOAuthProvider>
            </PersistGate>
        </Provider>
    );
}

export default App;
